import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-regular-svg-icons";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import {
  Accordion,
  Button,
  Modal,
  Nav,
  OverlayTrigger,
  Popover,
  Tab,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CogIcon from "../../assets/icons/cog.svg2";
import TokenEditor from "../Builder/Components/TokenEditor";
import HelpButton from "../HelpContent/HelpButton";
import BroadcastCommsSelector, {
  availableChannels,
} from "./BroadcastCommsSelector";
import StatusHandlers from "./StatusHandlers";
import ReplyHandlers from "./ReplyHandlers";
import BroadcastMethodSelector from "./BroadcastMethodSelector";
import BroadcastConfiguration from "./BroadcastConfiguration";
import BroadcastEditorTabs from "./BroadcastEditorTabs";
import {
  selectBroadcast,
  selectCurrentBroadcastChannel,
  setBroadcast,
  setCurrentBroadcastChannel,
} from "../store/slices/broadcastSlice";
import ReplyHandlersIcon from "../../assets/icons/icon_2_way-01.svg2";
import { createEditorState } from "../helpers";
import ImageUploadInput from "../Builder/nodes/Logic/Inputs/ImageUploadInput";

function SignatureModal() {
  const [show, setShow] = useState(false);

  const broadcastData = useSelector(selectBroadcast);
  const signatureEditorState =
    broadcastData.Messages.find((c) => c.Channel === "email")?.EmailSignature
      ?.EditorState || createEditorState();
  const dispatch = useDispatch();
  const setValues = (v) => dispatch(setBroadcast(v));

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="position-relative">
      <Button
        className="btn-colored rounded-3 position-absolute end-0 z-1 px-3 mt-2"
        style={{ fontSize: "0.75rem" }}
        onClick={handleShow}
      >
        <FontAwesomeIcon icon={faEdit} className="me-2" />
        EDIT SIGNATURE
      </Button>
      <TokenEditor
        preview="email"
        key={show}
        rawEditorState={signatureEditorState}
        onChange={() => {}}
      />

      <Modal
        size="xl"
        show={show}
        onHide={handleClose}
        contentClassName="bg-purple-gradient-darker"
      >
        <Modal.Header closeButton className="bg-purple-gradient-darker">
          <Modal.Title className="fw-bold">
            <div className="mx-3">
              Edit email signature <HelpButton helpKey="edit-email-signature" />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="row m-2 ">
            <div className="col-9"> */}
          <div className="bg-white rounded-3 my-3 large-editor p-3 ">
            <TokenEditor
              tokenTags={[""]}
              showShortlinksButton={false}
              showButtons
              rawEditorState={signatureEditorState}
              onChange={({
                rawEditorState,
                HTMLtext,
                tokens,
                plainText,
                links,
                shortlinks,
              }) => {
                setValues({
                  ...broadcastData,
                  Messages: broadcastData.Messages.map((pc) => {
                    if (pc.Channel === "email") {
                      return {
                        ...pc,
                        EmailSignature: {
                          EditorState: rawEditorState,
                        },
                      };
                    }
                    return pc;
                  }),
                });
              }}
              style={undefined}
              label={undefined}
              preview={undefined}
              initialText={undefined}
            />
          </div>
          <div className="d-flex justify-content-end">
            <Button
              className="bg-colored-reverse px-5 rounded-pill fw-bold "
              onClick={handleClose}
            >
              SAVE{" "}
            </Button>
          </div>
          {/* </div>
             <div className="fw-bold fs-5 p-3 col-3">
              <div>
                Media manager
                <HelpButton helpKey="edit-email-signature-media-manager" />
              </div>
              <hr className="text-secondary" />
              <div>
                Your logo:
                <HelpButton helpKey="edit-email-signature-your-logo" />
              </div>
              <div className="rounded-3 my-2">
                <ImageUploadInput />
              </div>
            </div> 
           </div> */}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default function BroadcastEditor({ confirmFixedBroadcast }) {
  const values = useSelector(selectBroadcast);
  const dispatch = useDispatch();
  const setValues = (v) => dispatch(setBroadcast(v));
  const currentChannel = useSelector(selectCurrentBroadcastChannel);

  return (
    <div className="row g-0">
      <div className="col-12 col-xxl-7 broadcast-editor mb-3">
        <Tab.Container
          mountOnEnter
          unmountOnExit
          id="broadcast-editor-channels-tabs"
          activeKey={currentChannel}
        >
          <Nav
            variant="tabs"
            className="bg-colored-reverse bg-accross pt-2 ps-2 rounded-top-3"
          >
            {values.Messages.map((c) => {
              const ChannelIcon = availableChannels[c.Channel].icon;
              return (
                <Nav.Item key={c.Channel}>
                  <Nav.Link
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(setCurrentBroadcastChannel(c.Channel));
                    }}
                    eventKey={c.Channel}
                    key={c.Channel}
                    className={`${
                      currentChannel === c.Channel
                        ? "text-purple"
                        : "text-white"
                    }`}
                  >
                    <span className="me-2">
                      <ChannelIcon width={20} />
                    </span>
                    {c.Channel}
                  </Nav.Link>
                </Nav.Item>
              );
            })}
            <div className="flex-grow-1" />
            <Nav.Item className="d-flex text-nowrap align-items-center">
              <OverlayTrigger
                trigger="click"
                rootClose
                placement="auto"
                overlay={
                  <Popover className="rounded-5 overflow-hidden">
                    <div
                      className="p-4 pb-5 bg-purple-gradient rounded-5"
                      style={{ width: 450 }}
                    >
                      <h5>Select communication channels</h5>
                      <hr className="border-secondary" />
                      <BroadcastCommsSelector />
                    </div>
                  </Popover>
                }
              >
                <button type="button" className="btn text-white">
                  Add channel
                  <FontAwesomeIcon icon={faCirclePlus} className="ms-2" />
                </button>
              </OverlayTrigger>
            </Nav.Item>
          </Nav>
          <Tab.Content className="bg-white p-3 rounded-bottom-3">
            <BroadcastMethodSelector
              confirmFixedBroadcast={confirmFixedBroadcast}
            />
            {/* method selector */}

            <div>
              <div>
                <div className="p-0 pb-2">
                  {values.Messages.length === 0 && (
                    <div className="text-center alert alert-warning p-3">
                      <h5 className="fw-bold">No message to display</h5>
                      <p>
                        Please add a communication channel to start creating a
                        message.
                      </p>
                    </div>
                  )}

                  {/* EDITOR TABS */}
                  <BroadcastEditorTabs
                    values={values}
                    setValues={setValues}
                    SignatureModal={SignatureModal}
                  />
                </div>
              </div>
              <Accordion>
                {
                  // Reply actions

                  values.CommsMethod === "two-way" && (
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        <div className="d-flex justify-content-between ">
                          <ReplyHandlersIcon
                            width={25}
                            className="my-2 bg-icon rounded-pill mx-2"
                          />

                          <div>
                            <span className="fw-bold text-navy">
                              Reply handlers:
                            </span>
                            <HelpButton helpKey="broadcast-reply-handlers" />
                            <span className="mx-2 badge bg-secondary rounded-pill">
                              {
                                (values.Handlers || []).filter(
                                  (h) => !h.IsDeliveryStatus
                                ).length
                              }
                            </span>
                            <div className="text-secondary small">
                              Manage and forward two-way message replies using
                              customisable reply handlers.
                            </div>
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body className="p-0">
                        <ReplyHandlers />
                      </Accordion.Body>
                    </Accordion.Item>
                  )
                }

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <div className="">
                      <div className="d-flex justify-content-between ">
                        <ReplyHandlersIcon
                          width={25}
                          className="my-2 bg-icon rounded-pill mx-2"
                        />

                        <div>
                          <span className="fw-bold text-navy">
                            Status handlers:
                          </span>
                          <HelpButton helpKey="broadcast-status-handlers" />
                          <span className="mx-2 badge bg-secondary rounded-pill">
                            {
                              (values.Handlers || []).filter(
                                (h) => h.IsDeliveryStatus
                              ).length
                            }
                          </span>
                          <div className="text-secondary small">
                            Message status tracks delivery and triggers actions
                            to optimise messaging.
                          </div>
                        </div>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body className="p-0">
                    <StatusHandlers />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </Tab.Content>
        </Tab.Container>
      </div>
      <div className="col-12 col-xxl-5">
        {/* Heading for small screen */}
        <div className="bg-colored-reverse bg-accross rounded-top-3 pt-2 d-xxl-none ">
          <span
            className="btn bg-white rounded-bottom-0 ms-2"
            style={{ height: 39 }}
          >
            <span className="me-2">
              <CogIcon width={20} />
            </span>
            CONFIGURATION
          </span>
        </div>
        {/* Heading for xxl screen */}
        <div
          className="bg-colored-reverse bg-accross rounded-top-3 rounded-start-0 pt-2 d-none d-xxl-block"
          style={{ marginLeft: -10 }}
        >
          <span
            className="btn bg-page rounded-bottom-0 fw-bold"
            style={{ height: 38, marginLeft: 10 }}
          >
            <span className="me-2 text-purple">
              <CogIcon width={20} />
            </span>
            CONFIGURATION
          </span>
        </div>

        <div className="">
          <BroadcastConfiguration
            confirmFixedBroadcast={confirmFixedBroadcast}
          />
        </div>
      </div>
    </div>
  );
}
